import type { Branded } from "@@/utilities/branded";

export const MILLISECOND = 1;
export const SECOND = 1000;
export const SECONDS = SECOND;
export const MINUTE = 60 * SECONDS;
export const MINUTES = MINUTE;
export const QUARTER = 15 * MINUTES;
export const QUARTERS = QUARTER;
export const HOUR = 4 * QUARTERS;
export const HOURS = HOUR;
export const DAY = 24 * HOURS;
export const DAYS = DAY;
export const WEEK = 7 * DAYS;
export const MONTH = 30 * DAYS;
export const YEAR = 365 * DAYS;

export type DAYS = Branded<number, "Days">;
export type DAY = DAYS;
export type HOURS = Branded<number, "Hours">;
export type HOUR = HOURS;
export type HOUR_UTC = HOURS;
export type MILLISECONDS = Branded<number, "Milliseconds">;
export type MINUTES = Branded<number, "Minutes">;
export type MINUTE = MINUTES;
export type MINUTE_UTC = MINUTES;
export type MONTHS = Branded<number, "Months">;
export type SECONDS = Branded<number, "Seconds">;
export type WEEKS = Branded<number, "Weeks">;
export type YEARS = Branded<number, "Years">;
